// Translations
import message from '../sections/message/translations/en'

// Translation: Error > Landing (English)
export default Object.freeze({
	sections: { message }
})
